import { render, staticRenderFns } from "./MediaPicker.vue?vue&type=template&id=acbdcca4"
import script from "./MediaPicker.vue?vue&type=script&lang=ts"
export * from "./MediaPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports